/**
 * Shared per-kind metadata for the public artifact list: the i18n label key and
 * the canonical Tabler icon for each artifact kind. Consumed by both the pill
 * tabs (`PublicArtifactList`) and the "All"-view section headers
 * (`PublicListSectionHeader`) so the kind → label/icon mapping has a single
 * source of truth.
 *
 * @module components/share/public/PublicArtifactList/parts/publicListKindMeta
 */
import type { ComponentType } from 'react';
import {
  IconAlertTriangle,
  IconChecklist,
  IconNote,
} from '@tabler/icons-react';

import type { PublicListKind } from './shareViewerFilterUtils';

/** i18n keys for each kind's plural label ("Zadania" / "Notatki" / ...). */
export const KIND_LABEL_KEYS: Record<PublicListKind, string> = {
  task: 'share.artifacts.tasks',
  note: 'share.artifacts.notes',
  obstruction: 'share.artifacts.obstructions',
};

/** Canonical artifact-type icons (mirrors the artifact registry definitions). */
export const KIND_ICONS: Record<
  PublicListKind,
  ComponentType<{ size?: number }>
> = {
  task: IconChecklist,
  note: IconNote,
  obstruction: IconAlertTriangle,
};
